/*
  Opulence luxury components.

  <lux-filter>: the filter row on listing pages. On phones it shows an
  arrow when the row can scroll sideways; the arrow scrolls it along and
  fades out once the shopper has scrolled. Keeps the active item in view.
*/
if (!customElements.get('lux-filter')) {
  customElements.define(
    'lux-filter',
    class LuxFilter extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.lux-filter__list');
        this.more = this.querySelector('.lux-filter__more');
        if (!this.list) return;

        this.update = this.update.bind(this);
        this.list.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        if (this.more) {
          this.more.addEventListener('click', () => {
            this.list.scrollBy({ left: this.list.clientWidth * 0.6, behavior: 'smooth' });
          });
        }
        this.revealActive();
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }

      update() {
        this.classList.toggle('has-overflow', this.list.scrollWidth - this.list.clientWidth > 4);
        this.classList.toggle('is-scrolled', this.list.scrollLeft > 8);
      }

      revealActive() {
        const active = this.querySelector('[aria-pressed="true"], [aria-current="page"]');
        if (!active || !window.matchMedia('(max-width: 989px)').matches) return;
        const offset = active.offsetLeft - (this.list.clientWidth - active.offsetWidth) / 2;
        this.list.scrollLeft = Math.max(0, offset);
      }
    }
  );
}

/* Sort menu: close when clicking elsewhere or pressing Escape */
document.addEventListener('click', function (e) {
  document.querySelectorAll('details.lux-sort[open]').forEach(function (d) {
    if (!d.contains(e.target)) d.removeAttribute('open');
  });
});
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  document.querySelectorAll('details.lux-sort[open]').forEach(function (d) {
    d.removeAttribute('open');
    var s = d.querySelector('summary');
    if (s) s.focus();
  });
});
